import { combineReducers } from "redux";
import { loginReducer } from "./LoginReducer";
import { routeReducer } from "./RouteReducer";
import { signUpReducer } from "./SignUpReducer";
import { validateReducer } from "./ValidateReducer";
import { editBandReducer } from "./EditBandReducer";
import { locationsReducer } from "./LocationsReducer";
import { errorReducer } from "./ErrorReducer";
import { forgottenPasswordReducer } from "./ForgottenPasswordReducer";
import { forgottenPasswordResetReducer } from "./ForgottenPasswordResetReducer";
import { resetPasswordReducer } from "./ResetPasswordReducer";
import { songReducer } from "./SongReducer";
import { deleteAccountReducer } from "./DeleteAccountReducer";

const rootReducer = combineReducers({
  login: loginReducer,
  routes: routeReducer,
  signup: signUpReducer,
  validate: validateReducer,
  editband: editBandReducer,
  locations: locationsReducer,
  error: errorReducer,
  forgottenPassword: forgottenPasswordReducer,
  forgottenPasswordReset: forgottenPasswordResetReducer,
  resetPassword: resetPasswordReducer,
  songs: songReducer,
  deleteAccount: deleteAccountReducer,
});

export default rootReducer;
